import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';
import CallCenterShiftsPage from '../pages/call-center/CallCenterShiftsPage';
import ShiftDetailsPage from '../pages/call-center/ShiftDetailsPage';
import CommissionListPage from '../pages/call-center/CommissionListPage';
import CommissionDetailsPage from '../pages/call-center/CommissionDetailsPage';
import StaffCommissionPage from '../pages/call-center/StaffCommissionPage';

const CallCenterRoutes = () => {
  return (
    <Routes>
      <Route
        path="shifts"
        element={
          <PermissionRoute requiredPermission="view_callcenter_shifts">
            <CallCenterShiftsPage />
          </PermissionRoute>
        }
      />
      <Route
        path="shifts/:id"
        element={
          <PermissionRoute requiredPermission="view_callcenter_shifts">
            <ShiftDetailsPage />
          </PermissionRoute>
        }
      />
      <Route
        path="commission"
        element={
          <PermissionRoute requiredPermission="view_callcenter_commission">
            <CommissionListPage />
          </PermissionRoute>
        }
      />
      <Route
        path="commission/:id"
        element={
          <PermissionRoute requiredPermission="view_callcenter_commission">
            <CommissionDetailsPage />
          </PermissionRoute>
        }
      />
      <Route
        path="staff-commission"
        element={
          <PermissionRoute
            requiredPermissions={['view_own_callcenter_commission', 'view_all_callcenter_commission']}
          >
            <StaffCommissionPage />
          </PermissionRoute>
        }
      />
    </Routes>
  );
};

export default CallCenterRoutes;
